import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'party',
    {
        'instance.created':   custom({ scope: 'access' }),
        'instance.deleted':   custom({ scope: 'access' }),
        'member.added':       custom({ scope: 'access' }),
        'member.removed':     custom({ scope: 'access' }),
        'template.published': custom({ scope: 'access' }),
        'template.archived':  custom({ scope: 'access' }),
        'template.updated':   custom({ scope: 'access' }),
    },
    { includeDefaultLifecycle: false },
);
